import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative w-full max-w-xl max-h-full z-50" }
const _hoisted_2 = { class: "relative bg-white rounded-lg shadow" }
const _hoisted_3 = { class: "flex justify-between py-3 px-6" }
const _hoisted_4 = { class: "text-2xl font-bold" }
const _hoisted_5 = {
  class: "p-6 flex gap-2 flex-col w-full",
  "data-testid": "test-slot-book-tour"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "p-6 flex justify-between items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_DbButton = _resolveComponent("DbButton")!

  return (_openBlock(), _createElementBlock("div", {
    id: "tour-slot-book-selector",
    class: _normalizeClass([_ctx.store?.state?.TourStore?.slotBookModal ? 'flex' : 'hidden', "fixed top-20 left-0 right-0 px-5 flex items-center justify-center z-50"]),
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-10" }, null, -1)),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("tour.slotBooking")), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_CalendarIcon)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slots, (groupSlots, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "flex gap-2"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupSlots, (slotData, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_ctx.selectSlot(slotData)),
                  class: _normalizeClass([
                _ctx.slot?.id === slotData.id ? 'border-green-400 bg-green-100' : ''
              , "flex grow flex-col p-1 rounded border-2 border-black justify-center items-center"])
                }, [
                  _createElementVNode("span", null, _toDisplayString(slotData.date), 1),
                  _createElementVNode("span", null, _toDisplayString(slotData.time), 1)
                ], 10, _hoisted_6))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_DbButton, {
            onOnClick: _ctx.close,
            class: "hydrated",
            variant: "secondary-solid"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("order.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onOnClick"]),
          (!_ctx.slot)
            ? (_openBlock(), _createBlock(_component_DbButton, {
                key: 0,
                variant: "brand-primary",
                disabled: true,
                class: "hydrated"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("tour.select_slot")), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_DbButton, {
                key: 1,
                variant: "brand-primary",
                onOnClick: _ctx.submit,
                class: "hydrated"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("tour.confirm_slot")), 1)
                ]),
                _: 1
              }, 8, ["onOnClick"]))
        ])
      ])
    ]),
    _createElementVNode("div", {
      "modal-backdrop": "",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
      class: _normalizeClass([_ctx.store?.state?.TourStore?.slotBookModal ? 'flex' : 'hidden', "bg-gray-900 bg-opacity-50 fixed inset-0 z-40"])
    }, null, 2)
  ], 2))
}